export const TIME_RANGE = 'issue_table_time_range_storage_3';

export const STACK_TYPE = 'stack_type_storage';
export const SEARCH_VALUES = 'search_value_storage_3';

// 缓存产品排序
export const PRODUCTS_SORT_STORAGE = 'products_sort_storage';


// 列表趋势分析是否展开
export const ISSUE_TREND_ANALYSIS_VISIBLE = 'issue-trend-analysis-visible';


export const DIMENSION_STORAGE = 'dimension';

export const STACK_STORAGE = 'stack-tab';

export const GC_VIEWED = 'gc-viewed';
